module.exports = __webpack_public_path__ + "img/flecha_azul_d.bf338bb5.svg";